import React from 'react'

export const Loading = ({ ...rest }) => (
  <div className="progress-line" {...rest}></div>
)
